import { render, staticRenderFns } from "./TablePelaku.vue?vue&type=template&id=2439464a&scoped=true&"
import script from "./TablePelaku.vue?vue&type=script&lang=js&"
export * from "./TablePelaku.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./TablePelaku.vue?vue&type=style&index=1&id=2439464a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2439464a",
  null
  
)

export default component.exports